/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Eyes_SInputs */

const en_funnel_ob_goal_eyes_s = /** @type {(inputs: Funnel_Ob_Goal_Eyes_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less screen time, listen anywhere`)
};

const es_funnel_ob_goal_eyes_s = /** @type {(inputs: Funnel_Ob_Goal_Eyes_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos pantalla, escucha donde quieras`)
};

/**
* | output |
* | --- |
* | "Less screen time, listen anywhere" |
*
* @param {Funnel_Ob_Goal_Eyes_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_eyes_s = /** @type {((inputs?: Funnel_Ob_Goal_Eyes_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Eyes_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_eyes_s(inputs)
	return en_funnel_ob_goal_eyes_s(inputs)
});